import axiosInstance from './ApiService';

/**
 * Fetch the latest competition data
 */
export const fetchCompetition = async () => {
    try {
        const response = await axiosInstance.get('/competitions?latest=true');
        const competitionData = response.data;

        const processedCompetitorsData = competitionData.competitors.map((competitor) => ({
            ...competitor,
            totalPoints: parseFloat(competitor.totalPoints),
            profilePicture: competitor.profilePicture || '/images/profiles/default.webp',
        }));

        const updatedCompetitionData = {
            ...competitionData,
            competitors: processedCompetitorsData,
            pointTarget: parseFloat(competitionData.pointTarget) || 0,
        };

        return updatedCompetitionData;
    } catch (error) {
        console.error('Error fetching competition data:', error);
        throw error;
    }
};

/**
 * Fetch the statistics for a specific competition
 * @param {string} competitionId - The ID of the competition
 */
export const fetchCompetitionStatistics = async (competitionId) => {
    try {
        const response = await axiosInstance.get(`/competitions/${competitionId}/statistics`);
        const statisticsData = response.data;
        return statisticsData

    } catch (error) {
        console.error(`Error fetching competition statistics for ID ${competitionId}:`, error);
        throw error;
    }
};

/**
 * Join the competition
 * @param {string} competitionId - The ID of the competition
 */
export const joinCompetition = async (competitionId) => {
    try {
        const response = await axiosInstance.post(`/competitions/${competitionId}/join`);
        return response.data;
    } catch (error) {
        console.error(`Error joining competition with ID ${competitionId}:`, error);
        throw error;
    }
};
